import { PaginatedResponse } from '@/types/PaginatedResponse'
import BaseService from './baseService'
import { CustomerSegmentResonse } from '@/types/customerSegmentResponse'
import EndPoints from '@/constants/dxApiEndpoints'

class SegmentService extends BaseService {
  async getCustomerSegment(
    businessProfileId: number,
    accountId: number,
    searchedText: string,
    pageNumber: number,
    pageSize: number,
    status: string
  ): Promise<PaginatedResponse<CustomerSegmentResonse>> {
    const customerSegmentResponse = await this.apiClient.get<
      PaginatedResponse<CustomerSegmentResonse>
    >(EndPoints.CustomerSegments(businessProfileId, accountId), {
      searchTerm: searchedText,
      pageNumber,
      pageSize,
      status
    })
    return customerSegmentResponse.data
  }

  async deleteSegment(
    businessProfileId: number,
    segmentId: number
  ): Promise<void> {
    await this.apiClient.delete<void>(
      EndPoints.DeleteSegment(businessProfileId, segmentId)
    )
  }
}

export default SegmentService
